<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
    <title>ico/58</title>
    <desc>Created with Sketch.</desc>
    <g
      id="ico/58"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      :opacity="opacity"
    >
      <circle
        id="Oval"
        :fill="color"
        fill-rule="nonzero"
        cx="16"
        cy="16"
        r="14"
      />
      <path
        id="Path-8"
        d="M21.9393398,10.9393398 C22.5251263,10.3535534 23.4748737,10.3535534 24.0606602,10.9393398 C24.6464466,11.5251263 24.6464466,12.4748737 24.0606602,13.0606602 L15.0606602,22.0606602 C14.4965376,22.6247827 13.5895453,22.6486344 12.9965529,22.1149412 L7.9965529,17.6149412 C7.38078787,17.0607527 7.33087025,16.1123179 7.88505878,15.4965529 C8.43924731,14.8807879 9.38768207,14.8308703 10.0034471,15.3850588 L13.9456438,18.9330358 L21.9393398,10.9393398 Z"
        fill="#FFFFFF"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    color: {
      type: String,
      default: '#42C27E'
    },
    opacity: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
    }
  }
}
</script>
